module.exports = __webpack_public_path__ + "static/media/AdditionalCoverage.761c2d05.svg";